// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2LrSR","filesListContainer":"PosDisputesFiles_filesListContainer__3BK1e","filesButton":"PosDisputesFiles_filesButton__2Hg-W"};